import React, { FC } from 'react';
import { BasicContainer, BodyText, FlexCol, FlexRow, LinkAsButton } from '@minecraft.atoms';
import { Trans, useTranslation } from '@blocs.i18n';
import { useUserContext } from '@blocs.auth';
import { gqlSubscriptionStatusEnum } from '@minecraft.graphql-types';

export const ResumeSubscriptionBanner: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { subscription } = useUserContext();
  const { formatIntlDate } = useTranslation();
  const date = formatIntlDate({ date: subscription?.resumeAt, format: 'MONTH_LONG_DAY_YEAR' });
  const isPausedSubscription = subscription?.status === gqlSubscriptionStatusEnum.PAUSED;

  if (!isPausedSubscription) return null;

  return (
    <FlexCol
      w="full"
      bgColor="warning"
      data-testid="resume-subcription-banner"
      minHeight={3}
      alignItems="center"
      justifyContent="center"
    >
      <BasicContainer m="4">
        <FlexRow w="fit" alignItems="center" gap="1">
          <BodyText align="center" fontWeight="medium">
            <Trans
              i18nKey="common:resumeSubscription.banner.content"
              components={{
                lnk: <LinkAsButton onClick={onClick} />,
              }}
              values={{ date }}
            />
          </BodyText>
        </FlexRow>
      </BasicContainer>
    </FlexCol>
  );
};
